import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { withRouter } from 'react-router'
import compose from '@shopify/react-compose'

import { withEndUser } from '@portal/kit/pkg/components'
import { handleServerErrors } from '@portal/kit/pkg/helpers'
import { updateUser } from '@portal/kit/pkg/services'

class EditContainer extends Component {

  updateUser = async values => {
    try {
      const response = await updateUser(values)

      this.props.user.setUser(response.data)
      this.props.history.push('/my-account', {
        notification: {
          status: 'success',
          message: this.props.successMessage
        }
      })
    }
    catch (e) {
      return handleServerErrors(e)
    }
  }

  render() {
    const { initialValues, validator, children } = this.props

    return (
      <Form
        onSubmit={this.updateUser}
        initialValues={initialValues}
        validate={validator}
        render={formProps => children(formProps) }
      />
    )
  }

}

EditContainer.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  validator: PropTypes.object,
  initialValues: PropTypes.object
}

EditContainer.defaultProps = {
  initialValues: {}
}

export default compose(
  withRouter,
  withEndUser,
)(EditContainer)
